import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './NotFoundPage.module.css';

const NotFoundPage = () => {
    const [currentJoke, setCurrentJoke] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    // Коллекция IT-анекдотов
    const itJokes = [
        "Почему программист всегда мокрый? Потому что он постоянно в бассейне с багами! 🐛",
        "Заходит программист в бар и говорит: 'Дайте мне чего-нибудь крепкого, мой код не компилируется...' 🍻",
        "Почему программисты путают Хэллоуин и Рождество? Потому что Oct 31 == Dec 25! 🎃🎄",
        "Программист звонит в поддержку: 'У меня ничего не работает!' Поддержка: 'А вы пробовали включить компьютер?' 💻",
        "Почему программист не любит природу? Потому что в ней слишком много багов и нет документации! 🌳",
        "Как программист называет своего сына? Сын_ок. А дочь? Дочь_эксепшн! 👨‍👧",
        "Программист на пляже: сидит в песке и пытается его скомпилировать... 🏖️",
        "Почему программист умер в душе? Потому что на шампуне было написано: 'Нанести, смыть, повторить.' 🚿",
        "Программист пишет завещание: 'Всё своё состояние оставляю жене, но только если она сможет найти его в моём коде.' 💰",
        "Почему программист всегда холодный? Потому что он постоянно работает с окнами! ❄️",
        "Программист на собеседовании: 'Ваши слабые стороны?' — 'Иногда я принимаю нуль за false, а false за нуль.' 🤔",
        "Почему программист не может приготовить яичницу? Потому что он всегда пытается отладить сковородку! 🍳",
        "Программист пришёл в ресторан и говорит: 'Принесите мне что-нибудь, что не жарьте, не варите и не запекайте.' Официант: 'А салат?' Программист: 'Нет, салат — это исключение.' 🥗",
        "Почему программист всегда ходит пешком? Потому что он знает, что автомобиль может сломаться, а баги сами не пофиксятся! 🚗",
        "Программист пошёл на свидание. Девушка спрашивает: 'Вы много зарабатываете?' Он: 'Ну, 1000000 в месяц, но это в двоичной системе.' 💑",
        "Почему у программиста всегда есть запасной план? Потому что он знает: если что-то может пойти не так, оно обязательно пойдет не так! 📋"
    ];

    useEffect(() => {
        // Выбираем случайный анекдот при загрузке
        const randomJoke = itJokes[Math.floor(Math.random() * itJokes.length)];
        setCurrentJoke(randomJoke);

        // Имитация загрузки для анимации
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    const handleNewJoke = () => {
        setIsLoading(true);
        setTimeout(() => {
            const newJoke = itJokes[Math.floor(Math.random() * itJokes.length)];
            setCurrentJoke(newJoke);
            setIsLoading(false);
        }, 500);
    };

    return (
        <div className={styles.notFound}>
            <div className={styles.container}>
                <div className={styles.content}>
                    <div className={styles.errorCode}>
                        <span className={styles.number}>4</span>
                        <span className={styles.emoji}>🤔</span>
                        <span className={styles.number}>4</span>
                    </div>

                    <h1 className={styles.title}>Ой-ой! Страница потерялась</h1>

                    <p className={styles.message}>
                        Кажется, эта страница отправилась в бесконечный цикл и не вернулась.
                        Возможно, её съели баги или она просто решила взять отгул. 🐞
                    </p>

                    <div className={styles.jokeSection}>
                        <h2 className={styles.jokeTitle}>А пока вот IT-анекдот:</h2>
                        <div className={`${styles.jokeContainer} ${isLoading ? styles.loading : ''}`}>
                            {isLoading ? (
                                <div className={styles.jokeLoader}>Загружаем юмор...</div>
                            ) : (
                                <>
                                    <p className={styles.joke}>{currentJoke}</p>
                                    <button
                                        className={styles.newJokeButton}
                                        onClick={handleNewJoke}
                                    >
                                        Другой анекдот 🔄
                                    </button>
                                </>
                            )}
                        </div>
                    </div>

                    <div className={styles.suggestions}>
                        <h3>Что можно сделать?</h3>
                        <ul>
                            <li>Вернуться на <Link to="/" className={styles.link}>главную страницу</Link></li>
                            <li>Проверить, не опечатались ли вы в адресе</li>
                            <li>Посмотреть <Link to="/about" className={styles.link}>о проекте</Link></li>
                            <li>Выпить кофе и подождать, пока страница сама найдётся ☕</li>
                        </ul>
                    </div>

                    <div className={styles.actions}>
                        <Link to="/" className={styles.homeLink}>
                            🏠 На главную
                        </Link>
                        <Link to="/create_post" className={styles.createLink}>
                            ✍️ Написать пост
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;